export default __webpack_public_path__ + "static/media/icon-arrow-up-gray.d3bcda30.svg";